module.exports = __webpack_public_path__ + "files/53bbc0d6dc2760afe9d66b6b8503a35f.png";